export const headTableCells = [
  {
    title: 'Dermpro Mapping',
    label: 'Dermpro Mapping',
    fieldName: 'catalogName',
    display: true,
    filter: true
  },
  {
    title: 'SKU',
    label: 'SKU',
    fieldName: 'sku',
    display: true,
    filter: true
  },
  {
    title: '<span>Revenue <span class="whitespace-no-wrap">Category 1</span></span>',
    label: 'Revenue Category 1',
    fieldName: 'revenueCategory1',
    display: true,
    filter: true
  },
  {
    title: '<span>Revenue <span class="whitespace-no-wrap">Category 2</span></span>',
    label: 'Revenue Category 2',
    fieldName: 'revenueCategory2',
    display: true,
    filter: true
  },
  {
    title: 'Brand',
    label: 'Brand',
    fieldName: 'catalogBrand',
    display: true,
    filter: true
  },
  {
    title: 'Manufacturer',
    label: 'Manufacturer',
    fieldName: 'manufacturer',
    display: true,
    filter: true
  },
  {
    title: 'Loyalty Program',
    label: 'Loyalty Program',
    fieldName: 'loyaltyProgram',
    display: true,
    filter: true
  },
  {
    title: 'Action',
    label: 'Action',
    align: 'text-center',
    display: true,
    filter: false
  }
];

export const searchFields = [
  {
    name: 'Revenue Category 1',
    value: 'revenueCategory1'
  },
  {
    name: 'Revenue Category 2',
    value: 'revenueCategory2'
  },
  {
    name: 'Brand',
    value: 'catalogBrand'
  },
  {
    name: 'Manufacturer',
    value: 'manufacturer'
  },
  {
    name: 'Loyalty',
    value: 'loyaltyProgram'
  },
];
